import {css} from 'aphrodite';
import React from 'react';

import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';

import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {getProcedureRunTaskDetailsSummaryRows} from '../procedures/getProcedureRunTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  ProcessTaskGql,
  getProcessTaskDetailsLabels,
} from '../ProcessTaskDetailsPageConstants';

export function getRecipeRunTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  const procedureRun = processTask.procedureRun;
  return getProcedureRunTaskDetailsSummaryRows(processTask, onUpdateTask, {
    label: getProcessTaskDetailsLabels().RECIPE_TEMPLATE,
    component:
      procedureRun != null ? (
        <ProcedurePageLinkForProcedureRun
          procedureRun={procedureRun}
          className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
        />
      ) : (
        <PlaceholderFieldValue />
      ),
  });
}
